import WalletConnect from "@walletconnect/client";
import QRCodeModal from "@walletconnect/qrcode-modal";
import { api, ui } from "services";
import { Chain, ContractType, LoginType } from "interfaces";
import { getContract, MAGContract, MSTRContract } from "services/contract";
import { toHex } from "services/utils";
import { clearUserInfo } from "reducer/user.slice";
import { clearAuthInfos } from "reducer/wallet.slice";
import { t } from "i18next";
import { store } from "reducer/store";
import { clearSession, setWalletSession } from "reducer/walletsession.slice";
import { SSO_META } from "config";

const bridge = "https://bridge.walletconnect.org";
let connector = new WalletConnect({
  bridge,
  qrcodeModal: QRCodeModal,
});
//@ts-ignore
const Web3 = window.Web3;
//@ts-ignore
const web3 = new Web3(Web3.givenProvider);
// const provider = new WalletConnectProvider({});

export const onConnect = async (payload: any, mode: string) => {
  const { chainId, accounts } = payload.params[0];
  const address = accounts[0];
  store.dispatch(
    setWalletSession({
      connected: true,
      chainId,
      accounts,
      address,
    })
  );
  if (mode === "signin") {
    loginByWalletConnect(address);
  } else if (mode === "signup") {
    signupByWalletConnect(address);
  }
};

export const onSessionUpdate = async (accounts: string[], chainId: number) => {
  console.log("on update");
  const address = accounts[0];
  store.dispatch(
    setWalletSession({
      chainId,
      accounts,
      address,
    })
  );
};

export const subscribeToEvents = async (mode: string) => {
  if (!connector) {
    return;
  }

  connector.on("session_update", async (error: any, payload: any) => {
    if (error) {
      console.log({ error });
      return;
    }

    const { chainId, accounts } = payload.params[0];
    await onSessionUpdate(accounts, chainId);
  });

  connector.on("connect", async (error: any, payload: any) => {
    console.log("connect");
    const { chainId } = connector;
    console.log({ chainId: toHex(chainId), test: chainId });
    const networkParams = SSO_META().network;
    let isSupported = Object.keys(networkParams).find((n: any) => networkParams[n].chainId === toHex(chainId));
    if (!isSupported) {
      ui.alertFailed("", "Your wallet's chain is not supported. Please switch to supported chains.");
      return;
    }

    if (error) {
      console.log({ error });
      return;
    }

    await onConnect(payload, mode);
  });

  connector.on("disconnect", async (error: any, payload: any) => {
    console.log("disconnect");
    if (error) {
      console.log({ error });
      return;
    }

    await logout();
  });

  if (connector.connected) {
    const { chainId, accounts } = connector;
    const address = accounts[0];
    store.dispatch(
      setWalletSession({
        connected: true,
        chainId,
        accounts,
        address,
      })
    );
    onSessionUpdate(accounts, chainId);
  }
};

export const loginByWalletConnect = async (address: any) => {
  try {
    let nonce = await api.getNonce();
    const sign = await connector.signPersonalMessage([nonce, address, "publicpassword"]);
    let { customerInfo, token, authInfos, is_2fa_enabled } = await api.post("/dao/login-dao", {
      sign,
      nonce,
    });
    await api.setStateLogin(token, customerInfo, authInfos, LoginType.BSC, true);
  } catch (error: any) {
    ui.alertFailed("", t(error?.message ?? error));
    await connector.killSession();
    store.dispatch(clearSession());
  }
};

export const signupByWalletConnect = async (address: any) => {
  try {
    let nonce = await api.getNonce();
    const sign = await connector.signPersonalMessage([nonce, address, "publicpassword"]);
    ui.showCaptcha(async (captcha: string) => {
      let { customerInfo, token, authInfos } = await api.post("/dao/register-by-wallet", {
        sign,
        nonce,
        type: 0,
        captcha,
      });
      await api.setStateLogin(token, customerInfo, authInfos, LoginType.BSC, true);
    });
  } catch (error: any) {
    ui.alertFailed(t(error?.message ?? error), "");
    await connector.killSession();
    store.dispatch(clearSession());
  }
};

export const connect = async (mode: string) => {
  const newConnector = new WalletConnect({ bridge, qrcodeModal: QRCodeModal });
  connector = newConnector;

  try {
    await connector?.killSession();
  } catch (err) {}

  if (!connector.connected) {
    console.log("create session");
    await connector.createSession();
  }
  await subscribeToEvents(mode);
};

const logout = async () => {
  if (connector) {
    await connector.killSession();
  }
  store.dispatch(clearUserInfo());
  store.dispatch(clearAuthInfos());
  sessionStorage.clear();
  localStorage.clear();
  store.dispatch(clearSession());
  window.location.href = "/";
};

const depositMstr = async (amount: any) => {
  throw new Error("not_support_walletconnect");

  let sessionData = store.getState().walletsession;
  const nonce = await web3.eth.getTransactionCount(sessionData.address, "latest");
  MSTRContract.options.address = getContract(ContractType.MSTR, Chain.BSC);
  const data = MSTRContract.methods
    .transfer(getContract(ContractType.STAKING, Chain.BSC), web3.utils.toWei(amount.toString(), "ether"))
    .encodeABI();
  const estimatedGas = await MSTRContract.methods
    .transfer(getContract(ContractType.STAKING, Chain.BSC), web3.utils.toWei(amount.toString(), "ether"))
    .estimateGas({
      from: sessionData.address,
    });

  // const customRequest = {
  //   id: 1337,
  //   jsonrpc: "2.0",
  //   method: "eth_signTransaction",
  //   params: [
  //     {
  //       from: sessionData.address,
  //       to: Config.AdminAddress,
  //       data, // Required
  //       gas: toHex(estimatedGas), // Optional
  //       value: toHex(amount.toString()), // Optional
  //       nonce: toHex(nonce),
  //     },
  //   ],
  // };

  const transaction = {
    from: sessionData.address,
    to: getContract(ContractType.STAKING, Chain.BSC),
    // data, // Required
    // gas: toHex(estimatedGas), // Optional
    // // value: toHex(web3.utils.toWei(amount.toString(), "ether")), // Optional
    // nonce: toHex(nonce),
    data,
    gasPrice: "0x02540be400", // Optional
    gas: toHex(estimatedGas), // Optional
    value: "0x00", // Optional
    nonce: "0x0114",
  };

  // const a = await connector.sendCustomRequest(customRequest);

  // console.log({ transaction });
  const result = await connector.sendTransaction(transaction);
};

const depositMAG = async (amount: any) => {
  throw new Error("not_support_walletconnect");
  let sessionData = store.getState().walletsession;
  const nonce = await web3.eth.getTransactionCount(sessionData.address, "latest");
  MAGContract.options.address = getContract(ContractType.MSTR, Chain.BSC);
  const data = MAGContract.methods
    .transfer(getContract(ContractType.STAKING, Chain.BSC), web3.utils.toWei(amount.toString(), "ether"))
    .encodeABI();
  const estimatedGas = await MSTRContract.methods
    .transfer(getContract(ContractType.STAKING, Chain.BSC), web3.utils.toWei(amount.toString(), "ether"))
    .estimateGas({
      from: sessionData.address,
    });

  // const customRequest = {
  //   id: 1337,
  //   jsonrpc: "2.0",
  //   method: "eth_signTransaction",
  //   params: [
  //     {
  //       from: sessionData.address,
  //       to: Config.AdminAddress,
  //       data, // Required
  //       gas: toHex(estimatedGas), // Optional
  //       value: toHex(amount.toString()), // Optional
  //       nonce: toHex(nonce),
  //     },
  //   ],
  // };

  const transaction = {
    from: sessionData.address,
    to: getContract(ContractType.Admin, Chain.BSC),
    data, // Required
    gas: toHex(estimatedGas), // Optional
    // value: toHex(web3.utils.toWei(amount.toString(), "ether")), // Optional
    nonce: toHex(nonce),
  };

  // const a = await connector.sendCustomRequest(customRequest);

  // console.log({ transaction });
  const result = await connector.sendTransaction(transaction);
};

const preventWalletConnect = () => {
  let isWalletConnect = sessionStorage.getItem("isWalletConnect");
  if (isWalletConnect) {
    ui.alertFailed(t("not_support_function_title"), t("not_support_walletconnect"));
    throw new Error("")
  }
};

const walletConnect = {
  preventWalletConnect,
  subscribeToEvents,
  onConnect,
  onSessionUpdate,
  loginByWalletConnect,
  signupByWalletConnect,
  connect,
  depositMstr,
  logout,
  depositMAG,
};

export default walletConnect;
